export default (fullName) => {
  if (!fullName) {
    return null
  }

  const name = fullName.split(' ')

  return [
    name[0],
    name[name.length - 1],
  ]
    .map((part) => part
      .trim()
      .substr(0, 1))
}
